const formatDateAsStrWithoutTZ = (date: string): string => {
  if (date) {
    const dateParts = date.split('T')[0].split('-');
    return `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`; // MM/DD/YYYY format
  }
  return '';
};

export default formatDateAsStrWithoutTZ;
